import { API } from 'common/modules/ReactShared';
import * as Template from '../../../_pagination';

import { selectors } from './selectors';
import { IItem } from './types';

const slice: Template.tPaginationSlice<IItem> = Template.createPaginationSlice<IItem>({
  name: 'completedLessons',
  perPage: 24,
  getItemsRequest: async (params) => {
    const response = await API.Profile.Lessons.Completed.getLessons({
      lesson_title_start: params.searchValue,
      page: params.page,
      per_page: params.perPage
    });
    const { lessons, ...pagination } = response;
    return { items: lessons, pagination };
  },
  removeItemRequest: () => {
    return Promise.resolve();
  },
  selectors
});

const { reducer, actions } = slice;

export { reducer, actions };
